import {
  formatWorkspaceDateTime,
  formatWorkspaceMoney,
  titleCaseLabel,
} from "./workspacePresentation";

export function formatMarketplaceMoneyFromCents(amountCents, currency = "cad") {
  return formatWorkspaceMoney(Number(amountCents || 0) / 100, currency);
}

export function formatMarketplaceDateTime(value) {
  return formatWorkspaceDateTime(value);
}

export function getMarketplaceReleaseTone(item = {}) {
  if (item.dispute_open) return "warning";
  const transferStatus = String(item.transfer_status || "").toLowerCase();
  const releaseStatus = String(item.release_status || "").toLowerCase();
  const bookingStatus = String(item.booking_status || "").toLowerCase();

  if (["released"].includes(transferStatus) || ["released"].includes(releaseStatus)) {
    return "success";
  }
  if (
    ["failed", "reversed"].includes(transferStatus) ||
    ["refunded"].includes(releaseStatus) ||
    ["refunded", "canceled"].includes(bookingStatus)
  ) {
    return "danger";
  }
  if (["eligible"].includes(releaseStatus)) {
    return "accent";
  }
  return "warning";
}

export function getMarketplaceReleaseLabel(item = {}) {
  if (item.dispute_open) return "Paused due to dispute";
  const transferStatus = String(item.transfer_status || "").toLowerCase();
  const releaseStatus = String(item.release_status || "").toLowerCase();
  const bookingStatus = String(item.booking_status || "").toLowerCase();

  if (["released"].includes(transferStatus) || ["released"].includes(releaseStatus)) {
    return "Released";
  }
  if (["failed"].includes(transferStatus)) {
    return "Release failed";
  }
  if (["reversed"].includes(transferStatus)) {
    return "Reversed";
  }
  if (["refunded"].includes(releaseStatus) || ["refunded"].includes(bookingStatus)) {
    return "Refunded";
  }
  if (["paused"].includes(transferStatus) || ["paused"].includes(releaseStatus)) {
    return "Paused";
  }
  if (["eligible"].includes(releaseStatus)) {
    return "Ready to release";
  }
  return "Pending release";
}

export function getMarketplaceBookingLabel(status) {
  return titleCaseLabel(status, "Pending");
}

export function getWorkspaceFinanceStateLabel(value) {
  const normalized = String(value || "").toLowerCase();
  if (!normalized) return "Finance Pending";
  if (normalized === "payment_method_required") return "Payment method required";
  if (normalized === "deposit_due") return "Deposit due";
  if (normalized === "deposit_held") return "Deposit held";
  if (normalized === "payment_captured") return "Payment captured";
  if (normalized === "payout_pending") return "Payout pending";
  if (normalized === "payout_released") return "Payout released";
  if (normalized === "payout_on_hold") return "Payout on hold";
  return titleCaseLabel(normalized, "Finance Pending");
}

export function getWorkspaceFinanceStateTone(value) {
  const normalized = String(value || "").toLowerCase();
  if (["payout_released", "payment_captured"].includes(normalized)) return "success";
  if (["disputed", "payout_on_hold"].includes(normalized)) return "warning";
  if (["refunded"].includes(normalized)) return "danger";
  if (["deposit_due", "payment_method_required"].includes(normalized)) return "accent";
  return "neutral";
}
